const buildHostsUrl = (hostIds: string[]): string => {
  const url = new URL(`${process.env.KOUTO_API_URL}/v1/users/hosts`);
  hostIds.forEach((id, index) => {
    url.searchParams.append(`userIds[${index}]`, id);
  });
  return url.toString();
};

export default buildHostsUrl;
